import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import { ActionContext } from "context/ActionContext";
import UserService from "services/UserService";
import { putAction, getAction } from "services/ConfigServices";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import {
  AutocompleteInput,
  CustomSelect,
  CustomSwitch,
  DateInput,
  FloatInput,
  IntInput,
  PictureInput,
  TextInput,
} from "components/Input/Index.js";
import EditButton from "components/CustomButtons/EditButton";
import { action as actionVar } from "variables/action";
import { reclevelData, statusData } from "variables/lists/action";

export default function ProgressEdit({ apiData, params, closeModal }) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;

  const [newProgress, setNewProgress] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewProgress((prevState) => ({
      ...prevState,
      [params]: { ...prevState.progress, [name]: value },
    }));
  };

  const handleToupdateChange = (e) => {
    setNewProgress((prevState) => ({
      ...prevState,
      [params]: {
        ...prevState.progress,
        toupdate: !prevState?.progress?.toupdate,
      },
    }));
  };

  useEffect(() => {
    console.log("action");
    setNewProgress(action?.parameters || {});
  }, [action]);

  const urlPlanAction = getAction(action.id);

  let url = putAction(action.id);

  const handleSubmit = (event) => {
    createActionProgress(event);
  };

  const createActionProgress = async (event) => {
    axios
      .put(url, newProgress, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
          'Content-Type': "application/json; charset=utf-8",
        },
      })
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setAction((prevState) => ({
            ...prevState,
            parameters: newProgress,
          }));
          setNotification("success", "État d'avancement modifée");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
        //setLoading(false);
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  return (
    <>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} xl={6}>
          <IntInput
            inputTitle={actionVar[params]["progresslevel"]}
            intInput={newProgress?.[params]?.["progresslevel"] || ""}
            handleIntInputChange={handleChange}
            name="progresslevel"
            disabled={!actionplanupdate}
          />
          <TextInput
            inputTitle={actionVar[params]["comments"]}
            textInput={newProgress?.[params]?.["comments"] || ""}
            handleTextInputChange={handleChange}
            name="comments"
            multiline
            rows={4}
            disabled={!actionplanupdate}
          />
          <CustomSwitch
            inputTitle={actionVar[params]["toupdate"]}
            checkedState={newProgress?.[params]?.["toupdate"] || false}
            handleSwitchChange={handleToupdateChange}
            name="toupdate"
            disabled={!actionplanupdate}
          />
        </GridItem>
      </GridContainer>
      {actionplanupdate && (
        <GridContainer>
          <GridItem
            xs={12}
            sm={12}
            md={7}
            lg={7}
            style={{ marginLeft: "8px", marginTop: "12px" }}
          >
            <EditButton handleSubmit={handleSubmit}>Modifier</EditButton>
          </GridItem>
        </GridContainer>
      )}
    </>
  );
}
